// import JS files
import { h, render } from 'preact';
import '../kickstart';
import './text-stats';
import './sticky-bar';
// import './countdown';
import StatewideTurnout from './statewide-turnout';
import Lookup from './lookup';
import TopCounties from './top-counties';

render(<StatewideTurnout />, document.getElementById('statewide-turnout'));
render(<Lookup />, document.getElementById('lookup'));
render(<TopCounties />, document.getElementById('top-counties'));
